import { TextField, Tooltip } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React from "react";
import "dayjs/locale/en-in";

const Calendar = ({ date, setDate }) => {
  const handleChange = (value) => {
    setDate(value);
  };

  // Format date for tooltip (full format)
  const fullDateText = date ? date.format("DD/MM/YYYY") : "";

  // Format date for display (short format)
  const shortDateText = date ? date.format("DD/MM") : "";

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"en-in"}>
      <Tooltip title={fullDateText} arrow placement="top">
        <div>
          <DesktopDatePicker
            label=""
            inputFormat="DD/MM"
            value={date}
            onChange={handleChange}
            textField={(params) => (
              <TextField
                {...params}
                size="small"
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
              />
            )}
          />
        </div>
      </Tooltip>
    </LocalizationProvider>
  );
};

export default Calendar;
